import React from "react";

interface TabToolbarProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

export const TabToolbar: React.FC<TabToolbarProps> = ({ left, right }) => (
  <div className="participant-card-toolbar flex items-center justify-between gap-3 px-3 py-2">
    <div className="flex items-center gap-2 flex-wrap">{left}</div>
    <div className="flex items-center gap-2 flex-wrap">{right}</div>
  </div>
);
